// components/MyPage/components/SecuritySettings.js
import React from "react";
import { Save } from "lucide-react";
import { 
  ContentHeader, 
  ContentTitle, 
  Form, 
  FormGroup, 
  Label, 
  Input, 
  SaveButton 
} from "./css";;

const SecuritySettings = ({ formData, handleChange, handlePasswordChange }) => {
  return (
    <>
      <ContentHeader>
        <ContentTitle>보안 설정</ContentTitle>
      </ContentHeader>
      <Form onSubmit={handlePasswordChange}>
        <FormGroup>
          <Label htmlFor="currentPassword">현재 비밀번호</Label>
          <Input
            type="password"
            id="currentPassword"
            name="currentPassword"
            value={formData.currentPassword}
            onChange={handleChange}
          />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="newPassword">새 비밀번호</Label>
          <Input
            type="password"
            id="newPassword"
            name="newPassword"
            value={formData.newPassword}
            onChange={handleChange}
          />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="confirmPassword">비밀번호 확인</Label>
          <Input
            type="password"
            id="confirmPassword"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
          />
        </FormGroup>
        <SaveButton type="submit">
          <Save size={16} />
          비밀번호 변경
        </SaveButton>
      </Form>
    </>
  );
};

export default SecuritySettings;